import { TYPES } from "@/view/ProseMirrorNode/ProseMirrorNode.constants";

/**
 * Checks that the node has valid and necessary attributes.
 *
 * @param {object} node
 * @returns {boolean}
 */
const rawTextNodeIsInvalid = (node) => {
  switch (node?.type) {
    case TYPES.powerWord:
    case TYPES.keyTerm:
      return (
        !node?.content?.[0]?.text?.length || !node?.attrs?.definition?.length
      );
    default:
      return false;
  }
};

export default rawTextNodeIsInvalid;
